import React from "react";
import { GRADIENTS } from "../../../constant/theme";

const WeddingAnniversaryCard = ({ data, hasPermission }) => {
  const anniversaries = data?.todays_wedding_anniversary_list || [];

  if (hasPermission && !hasPermission("dashboard-birthday-list-view")) {
    return null;
  }

  return (
    <div className="col-lg-4 col-md-6 mb-4">
      <div
        className="card text-white dashboard-insight-glass-card"
        style={{
          background: GRADIENTS.birthdayCard,
          position: "relative",
        }}
      >
        <div className="card-body position-relative z-1 d-flex flex-column">
          <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}>💍</div>

          {anniversaries.length > 0 ? (
            <>
              <div className="avatar-group insight-avatar-group d-flex align-items-center mb-4 flex-wrap">
                {anniversaries.slice(0, 10).map((user, i) => (
                  <div
                    key={i}
                    className="avatar avatar-md"
                    title={`${user?.name || user?.company_name}`}
                    style={{
                      borderRadius: "50%",
                      cursor: "pointer",
                      width: "42px",
                      height: "42px",
                      marginLeft: i === 0 ? "0" : "-10px",
                    }}
                  >
                    <img
                      src={
                        user?.thumb_profile_image ||
                        user?.profile_image ||
                        "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80"
                      }
                      alt="Avatar"
                      className="rounded-circle"
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </div>
                ))}
                {anniversaries.length > 10 && (
                  <div
                    className="avatar avatar-md d-flex align-items-center justify-content-center"
                    style={{
                      borderRadius: "50%",
                      width: "42px",
                      height: "42px",
                      backgroundColor: "rgba(255,255,255,0.2)",
                      marginLeft: "-10px",
                      zIndex: 10,
                    }}
                  >
                    <span className="fw-bold text-white fs-6">
                      +{anniversaries.length - 10}
                    </span>
                  </div>
                )}
              </div>

              <p
                style={{
                  color: "#ffd54f",
                  fontWeight: "600",
                  marginBottom: "4px",
                  fontSize: "0.9rem",
                }}
              >
                {anniversaries.length} Wedding Anniversar
                {anniversaries.length > 1 ? "ies" : "y"}
              </p>
              <h5
                className="text-white mb-3"
                style={{ fontWeight: "700", fontSize: "1.3rem" }}
              >
                Wish Your Members!
              </h5>
            </>
          ) : (
            <div className="d-flex flex-column justify-content-center flex-grow-1 mt-2">
              <h4 className="text-white mb-2" style={{ fontWeight: "700" }}>
                No Anniversaries Today!
              </h4>
              <p
                className="mb-0"
                style={{
                  color: "rgba(255,255,255,0.85)",
                  fontSize: "0.9rem",
                  lineHeight: "1.5",
                }}
              >
                Looks like it's a quiet day. Check back tomorrow to see if anyone
                is celebrating!
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WeddingAnniversaryCard;
